import * as Yup from "yup";

import { AuthKeys, BillingAddressSignUpKeys, CountryKeys, OrganisationSignUpKeys, validationMsgs } from "@sso/constant";
import { Country } from "@sso/types";
import { regexPasswordValidation } from "@sso/utils";

export const signUpPersonalValidation = Yup.object({
  [AuthKeys.FIRST_NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(20, validationMsgs.maxlength(20)),
  [AuthKeys.LAST_NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(20, validationMsgs.maxlength(20)),
  [AuthKeys.USER_NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(50, validationMsgs.maxlength(50)),
  [AuthKeys.EMAIL]: Yup.string()
    .required(validationMsgs.required)
    .email(validationMsgs.email)
    .max(100, validationMsgs.maxlength(100)),
  [AuthKeys.PASSWORD]: Yup.string()
    .required(validationMsgs.required)
    .min(8, validationMsgs.minlength(8))
    .max(50, validationMsgs.maxlength(50))
    .matches(regexPasswordValidation, validationMsgs.complexPassword),
  [AuthKeys.CONFIRM_PASSWORD]: Yup.string()
    .required(validationMsgs.required)
    .oneOf([Yup.ref(AuthKeys.PASSWORD), null], validationMsgs.equalTo),
});

export const signUpOrgValidation = Yup.object({
  [OrganisationSignUpKeys.NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(50, validationMsgs.maxlength(50)),
  [OrganisationSignUpKeys.BILLING_EMAIL]: Yup.string()
    .required(validationMsgs.required)
    .email(validationMsgs.email)
    .max(100, validationMsgs.maxlength(100)),
  [OrganisationSignUpKeys.ADDRESS]: Yup.object({
    [BillingAddressSignUpKeys.FIRST_LINE]: Yup.string().required(validationMsgs.required),
    [BillingAddressSignUpKeys.SECOND_LINE]: Yup.string(),
    [BillingAddressSignUpKeys.CITY]: Yup.string().required(validationMsgs.required),
    [BillingAddressSignUpKeys.STATE]: Yup.string(),
    [BillingAddressSignUpKeys.POSTCODE]: Yup.string(),
    [BillingAddressSignUpKeys.COUNTRY_ID]: Yup.string().required(validationMsgs.required),
    [BillingAddressSignUpKeys.COUNTRY]: Yup.object(),
  }),
  [OrganisationSignUpKeys.PHONE]: Yup.string().max(20, validationMsgs.maxlength(25)),
  [OrganisationSignUpKeys.VAT_NUMBER]: Yup.string()
    .max(20, validationMsgs.maxlength(20))
    .when(`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.COUNTRY_ID}`, {
      is: (countryId: string) => !countryId,
      then: Yup.string().required("Please select a country"),
    })
    .when(`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.COUNTRY}`, {
      is: (country: Country) => country?.[CountryKeys.IS_EU] || country?.[CountryKeys.COUNTRY_CODE] === "GB",
      then: Yup.string().required("VAT number is required for UK and EU based organisations"),
    }),
  [OrganisationSignUpKeys.ORGANISATION_TRANSACTION_CURRENCY_CODE]: Yup.string().required(validationMsgs.required),
});
